<template>
  <div v-if="permissoes.editar_contatos || permissoes.ler_contatos">
    <!-- Breadcrumb e Cabeçalho -->
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Contatos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!-- Título -->
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Contatos do Fabricante</h1>
      </el-col>
    </el-row>
    <!-- Vendedor -->
    <el-row type="flex" justify="start">
      <el-col :span="24">

        <el-form :model="fabricante" ref="formRepresentante" :rules="rules2" style="text-align: left">
          <el-form-item label="Representante" prop="_id">
            <el-select
              v-model="fabricante.representante_id"
              filterable
              placeholder="Informe o Representante"
              class="select-representante"
            >
              <el-option
                v-for="item in representantes"
                :key="item.id"
                :label="item.nome"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-finished" @click="submitRepresentante()" v-if="permissoes.editar_contatos">Salvar</el-button>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
    <!-- Botão Novo -->
    <el-row type="flex" style="text-align: left; margin-bottom: 10px;">
      <el-col :span="24">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          v-if="permissoes.editar_contatos"
          @click="openForm()"
        >Novo</el-button>
      </el-col>
    </el-row>
    <!-- Tabela -->
    <el-row type="flex" justify="start" aling="left">
      <el-col :span="24">
        <el-table
          :data="contatos"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
        >
          <el-table-column prop="sge_cliente" label="Fabricante" width="95"></el-table-column>
          <el-table-column prop="nome" label="Nome" min-width="250" sortable></el-table-column>
          <el-table-column prop="email" label="Email" min-width="250" sortable></el-table-column>
          <el-table-column prop="telefone" label="Telefone" width="120" sortable></el-table-column>
          <el-table-column prop="cargo" label="Cargo" width="160" sortable></el-table-column>
          <el-table-column label="Ação" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="openForm(scope.row)">Editar</el-button>
              <el-button
                v-if="permissoes.excluir_contatos"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >Excluir</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- Formulário -->
    <el-dialog
      :title="form.id ? 'Editar Contato' : 'Novo Contato'"
      :visible.sync="dialogFormVisible"
      :show-close="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="formContato"
        label-position="right"
        label-width="100px"
      >    
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="form.nome" />
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="Telefone" prop="telefone">
          <el-input v-model="form.telefone" />
        </el-form-item>
        <el-form-item label="Cargo" prop="cargo">
          <el-input v-model="form.cargo" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">Cancelar</el-button>
        <el-button type="primary" @click="submitContato()">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../plugins/FuncoesUteis";

const url = "/api";

export default {


  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      permissoes: {},
      fabricante: {},
      representantes: [],
      contatos: [],
      form: {},
      rules: {
        nome: [
          { required: true, message: "Por Favor, informe o Nome", trigger: "blur" },
          { min: 3, message: "Deve ter pelo menos 3 caracteres", trigger: "blur" },
        ],
        email: [
          { required: true, message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
      },
      rules2: {
      representante_id: [
        { required: true, message: 'Por favor, selecione um representante', trigger: 'change' }
      ]
    },
    };
  },


  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.ler_contatos) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.getDados();
  },


  methods: {


    async getDados() {
      await this.buscarFabricante();
      await this.buscarRepresentantes();
      await this.buscarContatos();
    },


    async buscarFabricante() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/fabricante/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.fabricante = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Fabricante: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarRepresentantes() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/vendedores-recursivo/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.representantes = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Representantes: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarContatos() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/fabricante-contato/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.contatos = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Contatos: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    openForm(row = null) {
      if (row) {
        this.form = { ...row };
      } else {
          this.form = { 
            id: null,
            fabricante_id: this.fabricante.fabricante_id,
            nome: null,
            email: null,
            sge_cliente: null,
            telefone: null,
            cargo: null,
         };
      }
      this.dialogFormVisible = true;
    },


    handleClose() {
      this.$confirm("Deseja fechar sem salvar?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
        })
        .catch(() => {});
    },


    submitContato() {
      this.$refs.formContato.validate((valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        const headers = { Authorization: "Bearer " + this.$store.state.token };
        const payload = { ...this.form };

        const request = this.form.id
          ? axios.put(`${url}/fabricante-contato/${this.form.id}`, payload, { headers })
          : axios.post(`${url}/fabricante-contato/`, payload, { headers });

        request
          .then(() => {
            this.$notify({
              title: "Sucesso",
              message: this.form.id ? "Registro atualizado!" : "Registro criado!",
              type: "success",
            });
            this.dialogFormVisible = false;
            this.getDados();
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message: "Falha ao salvar os dados. " + err,
              type: "error",
            });
          });
      });
    },


    submitRepresentante() {
      this.$refs.formRepresentante.validate((valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        const headers = { Authorization: "Bearer " + this.$store.state.token };
        const payload = { ...this.fabricante };

        const request = this.fabricante.id
          ? axios.put(`${url}/fabricante/${this.fabricante.id}`, payload, { headers })
          : axios.post(`${url}/fabricante/`, payload, { headers });

        request
          .then(() => {
            this.$notify({
              title: "Sucesso",
              message: this.form.id ? "Registro atualizado!" : "Registro criado!",
              type: "success",
            });
            this.dialogFormVisible = false;
            this.getDados();
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message: "Falha ao salvar os dados. " + err,
              type: "error",
            });
          });
        });
    },


    handleDelete(row) {
      this.$confirm("Deseja excluir este registro?", "Confirmação", {
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(`${url}/fabricante-contato/${row.id}`, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            })
            .then(() => {
              this.$notify({ title: "Sucesso", message: "Registro excluído!", type: "success" });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({ title: "Erro", message: "Falha ao excluir. " + err, type: "error" });
            });
        })
        .catch(() => {});
    },
  },


};

</script>

<style scoped>
.select-representante {
  width: 60%;
  margin-right: 10px;
}
</style>
